"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _redux = require("redux");

var _run = require("@cycle/run");

var _reduxCycles = require("redux-cycles");

var _http = require("@cycle/http");

var _reducer = _interopRequireDefault(require("./reducer"));

var _cycles = _interopRequireDefault(require("./cycles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _default = function _default(actionData) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var extraReducers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var extraMiddlewares = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var cycleMiddleware = (0, _reduxCycles.createCycleMiddleware)();
  var middewares = (0, _ramda.append)(cycleMiddleware, extraMiddlewares);
  var isArr = isDataArray(actionData);
  var exReducerKeys = Object.keys(extraReducers);
  if (exReducerKeys.length > 0 && !isArr) throw new Error('A name must be provided for the default reducer.');
  var reducers = !isArr ? (0, _reducer.default)(actionData) : (0, _redux.combineReducers)(Object.assign({}, (0, _ramda.fromPairs)(Object.keys(actionData).map(function (r) {
    return [r, (0, _reducer.default)(actionData[r])];
  })), extraReducers));
  var store = (0, _redux.createStore)(reducers, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, _toConsumableArray(middewares)), process && process.env && process.env.NODE_ENV === 'development' && window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  }));
  (0, _run.run)(_reduxCycles.combineCycles.apply(void 0, _toConsumableArray((0, _cycles.default)(actionData))), {
    ACTION: cycleMiddleware.makeActionDriver(),
    HTTP: (0, _http.makeHTTPDriver)()
  });
  return store;
};

exports.default = _default;

var isDataArray = function isDataArray(d) {
  return (0, _ramda.is)(Object, d) && Object.keys(d).every(function (x) {
    return (0, _ramda.is)(Object, d[x]) && !(0, _ramda.isEmpty)(d[x]) && Object.keys(d[x]).every(function (y) {
      return (0, _ramda.is)(Object, d[x][y]);
    });
  });
};